export default __webpack_public_path__ + "static/media/cafe_bazzar.6b470e8e.png";